module.exports = __webpack_public_path__ + "img/task2088.34fa3c88.png";